module.exports = __webpack_public_path__ + "img/Partners4.32002922.png";